var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"mask",rawName:"v-mask",value:(/\d{0,100}/),expression:"/\\d{0,100}/"}],attrs:{"type":"text"}})}
var staticRenderFns = []

export { render, staticRenderFns }